import { render, staticRenderFns } from "./RuleActionBuilder.vue?vue&type=template&id=60ac7fc1"
import script from "./RuleActionBuilder.vue?vue&type=script&lang=ts"
export * from "./RuleActionBuilder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports